module.exports = __webpack_public_path__ + "static/media/key.3c3a33c1.png";